// utils/handleApiError.js
import { toast } from 'react-hot-toast';

export const handleApiError = (err, message) => {
  console.log('====================================');
  console.log('Custom Message:', message);
  console.log('Error:', err);
  console.log('====================================');

  // Auth errors handled globally
  if (err?.__handledAuthError) return;

  // Ignore intentional cancellations
  if (err?.name === 'CanceledError' || err?.name === 'AbortError') {
    return;
  }

  console.error(err);

  const apiMessage =
    err?.response?.data?.message ||
    err?.response?.data?.detail ||
    err?.response?.data?.error ||
    err?.message;

  toast.error(
    apiMessage || message || 'Something went wrong. Please try again.'
  );
};
